import { useState } from 'react';
import type { AppNoticeImage as AppNoticeImageProps } from '../../types/notices/app-notice.type';

/**
 * Renders bounded notice imagery and hides a failed source without hiding the notice.
 * @param props - Image source and localized alternative text.
 * @returns The illustration, or null after that source fails.
 */
export const AppNoticeImage = ({ src, alt }: AppNoticeImageProps) => {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  if (failedSource === src) return null;
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setFailedSource(src)}
      className="h-12 w-16 shrink-0 rounded-md border border-blue-100 object-cover md:h-16 md:w-24"
    />
  );
};
